export default __webpack_public_path__ + "static/media/pic2.036652c9.JPG";